if (process.client) {
  require("babel-polyfill")
}
